export default ({ loading }, { loadingKeys = [] }) => {
  let loadingMsg = { show: false }
  let i = 0
  let len = loadingKeys.length

  for (i; i < len; i++) {
    const data = loading[loadingKeys[i]]
    if (data) {
      if (data.successMessage) {
        loadingMsg = {
          show: true,
          success: data.success,
          message: data.success ? data.successMessage : data.message,
        }
      } else {
        loadingMsg = { show: true, ...data }
      }
      break
    }
  }

  return { loading: loadingMsg }
}
